/* eslint-disable react/jsx-props-no-spreading */
import { MultiValueLabelCustomProps } from '@/components/Purchases/components/SelectOkpd2/components/MultiValueLabel.js';
import React from 'react';
import { MenuProps } from 'react-select';
import { GroupBase } from 'react-select';
import { components } from 'react-select';
import Loader from '../../Loader.js';

export interface MenuCustomProps {
  isLoading: boolean;
}

export const Menu = <
  Option,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  ...props
}: MenuProps<Option, IsMulti, Group>) => {
  const { isLoading } = (
    props.selectProps as unknown as { customProps: MenuCustomProps }
  ).customProps;

  return (
    <components.Menu {...props}>
      {isLoading && <Loader />}
      {children}
    </components.Menu>
  );
};
